function toggleContent(trigger) {
  // Find the next sibling content div
  const contentDiv = trigger.nextElementSibling;
  const icon = trigger.querySelector(".icon");

  // Toggle the 'hidden' class on content div
  contentDiv.classList.toggle("hidden");

  // Update the icon based on visibility
  if (contentDiv.classList.contains("hidden")) {
    icon.textContent = "+"; // Change icon to "+"
  } else {
    icon.textContent = "-"; // Change icon to "-"
  }
}
/* Share Button js start here */
/* Product information share btn */


  // Accordion functionality
  var acc = document.getElementsByClassName("Share-accordion-lat");

  for (var i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
      this.classList.toggle("active");

      var panel = this.nextElementSibling;

      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";

        // Make panel focusable and focus it
        panel.setAttribute("tabindex", "0");
        panel.focus();

        // Add Escape key listener to close panel
        panel.onkeydown = function (event) {
          if (event.key === "Escape") {
            panel.style.display = "none";
            panel.previousElementSibling.classList.remove("active"); // Remove active from button
            panel.blur(); // optional: remove focus
          }
        };
      }
    });
  }

  // Optional: Close all panels on Escape (global fallback)
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      var openPanels = document.querySelectorAll(".Share-accordion-lat.active");
      openPanels.forEach(function (btn) {
        btn.classList.remove("active");
        var panel = btn.nextElementSibling;
        if (panel && panel.style.display === "block") {
          panel.style.display = "none";
        }
      });
    }
  });




/* Bunlde share btn - 1*/
function toggleShareContent1() {
  const content1 = document.getElementById("shareBoxBundle");
  if (content1.style.display === "block") {
    content1.style.display = "none"; // Hide content
  } else {
    content1.style.display = "block"; // Show content
  }
}

var mob_bundle_acc = document.getElementsByClassName("mob-bundle-share-acc");
var i;
/* Mobile Bunlde share btn - 1*/

for (i = 0; i < mob_bundle_acc.length; i++) {
  mob_bundle_acc[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

/* Mobile Bunlde share btn - 2*/

var mob_bundle_acc_2 = document.getElementsByClassName(
  "mob-bundle-share-acc-2"
);
var i;

for (i = 0; i < mob_bundle_acc_2.length; i++) {
  mob_bundle_acc_2[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

//document.querySelector(".bundle-share-btn").onclick = toggleShareContent1;

/* Bunlde share btn - 1*/

function toggleShareContent2() {
  const content2 = document.getElementById("shareBoxBundle2");
  if (content2.style.display === "block") {
    content2.style.display = "none"; // Hide content
  } else {
    content2.style.display = "block"; // Show content
  }
}

/* Recommonede share btn */

function toggleShare(forloopIndex) {
  const content = document.getElementById("shareContent" + forloopIndex);

  // Toggle the display of the content
  if (content.style.display === "block") {
    content.style.display = "none";
  } else {
    content.style.display = "block";
  }
}

/* Search share btn */

function Sharebtn(forloopIndex) {
  const allContents = document.querySelectorAll("[id^='rvp-share-content-']");
  const selectedContent = document.getElementById("rvp-share-content-" + forloopIndex);

  // If the selected dropdown is already visible, hide it and return early
  if (selectedContent.style.display === "block") {
    selectedContent.style.display = "none";
    return;
  }

  // Hide all dropdowns
  allContents.forEach(content => {
    content.style.display = "none";
  });

  // Show the selected dropdown
  if (selectedContent) {
    selectedContent.style.display = "block";
    selectedContent.setAttribute("tabindex", "0");
    selectedContent.focus();

    selectedContent.onkeydown = null;
    selectedContent.onkeydown = function(event) {
      if (event.key === "Escape") {
        selectedContent.style.display = "none";
      }
    };
  }
}




// Assign toggleShare to the button click event
//document.querySelector(".bundle-share-btn-2").onclick = toggleShareContent2;

// Collection carousle share bt
function toggleShare(forloopIndex) {
  const content = document.getElementById("shareContent" + forloopIndex);

  if (content.style.display === "block") {
    content.style.display = "none";
  } else {
    content.style.display = "block";

    // Make it focusable and focus so keydown can be detected
    content.setAttribute("tabindex", "0");
    content.focus();

    // Remove previous keydown to avoid duplicates
    content.onkeydown = null;

    // Add Escape key listener
    content.onkeydown = function(event) {
      if (event.key === "Escape") {
        content.style.display = "none";
      }
    };
  }
}


function shareToFacebook(event, productUrl) {
  event.preventDefault(); // Prevent default anchor behavior
  window.open(
    `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      productUrl
    )}?utm_source=pdp&utm_medium=link-share&utm_campaign=facebook`,
    "_blank"
  );
}

function shareToTwitter(event, productUrl, productTitle) {
  event.preventDefault(); // Prevent default anchor behavior
  const text = encodeURIComponent(productTitle);
  window.open(
    `https://www.instagram.com/nintarababyindia?utm_source=pdp&utm_medium=link-share&utm_campaign=instagram`,
    "_blank"
  );
}

function shareToWhatsApp(event, productUrl) {
  event.preventDefault(); // Prevent default anchor behavior
  window.open(
    `https://wa.me/?text=${encodeURIComponent(
      productUrl
    )}?utm_source=pdp&utm_medium=link-share&utm_campaign=whatsapp`,
    "_blank"
  );
}

function copyLink(event, productUrl) {
  event.preventDefault(); // Prevent default anchor behavior

  // Check if the URL already contains a query string
  const separator = productUrl.includes("?") ? "&" : "?";

  // Append UTM parameters to the product URL
  const utmUrl =
    productUrl +
    separator +
    "utm_source=pdp&utm_medium=link-share&utm_campaign=copy";

  // Copy the updated URL to clipboard
  navigator.clipboard
    .writeText(utmUrl)
    .then(() => {
      alert("Link copied to clipboard!");
    })
    .catch((err) => {
      console.error("Failed to copy: ", err);
      alert("Failed to copy link. Please try again.");
    });
}

/* Share Button js end  here */
